export const NavTabs = "atlantis-nav-tabs";
export const NavTabPane = "atlantis-nav-tab-pane";
export const PageTabs = "atlantis-page-tabs";
